import React from 'react';
import styles from '../Styles/EventOps.module.css';
import { LEAD_STAGE, STAGE_LABELS } from './placeholders';

/** Stage chips, named as the funnel cards. `value` is the selected stage keys;
 * `onChange` gets the new list, in `allowed` order. `lead` is exclusive: a
 * playbook campaign targets either leads or event stages, never both, so
 * picking one side clears the other. */
export default function StagePicker({ value = [], onChange, allowed = Object.keys(STAGE_LABELS) }) {
  const selected = new Set(value);
  const toggle = (stage) => {
    let next = new Set(selected);
    if (next.has(stage)) next.delete(stage);
    else if (stage === LEAD_STAGE) next = new Set([LEAD_STAGE]);
    else {
      next.delete(LEAD_STAGE);
      next.add(stage);
    }
    onChange?.(allowed.filter((s) => next.has(s)));
  };
  return (
    <span className={styles.chips}>
      {allowed.map((s) => (
        <button
          key={s}
          type="button"
          aria-pressed={selected.has(s)}
          className={`${styles.stageChip} ${selected.has(s) ? styles.stageChipOn : ''}`}
          onClick={() => toggle(s)}
        >
          {STAGE_LABELS[s] ?? s}
        </button>
      ))}
    </span>
  );
}
